// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

export const shouldUpdateScroll = args => {
    return false;
};
